export default __webpack_public_path__ + "static/stock-chart-e0cada15d9355bcac9936ee302032484.jpg";